import React from "react";
import BlackList from "./black-list";
import ControlButtons from "../control-buttons/control-buttons";

class BlackListController extends React.Component{

    constructor(props){
        super(props);

        this.state = ({
            selectedTopics: this.props.selectedTopics ? this.props.selectedTopics.join(',') : '',
            topicBlackList: this.props.topicBlackList
        })
    }

    getTopicIds = () => {
        let topicIds = [];
        if(this.props.topics && this.props.topics.length){
            topicIds = this.props.selectedTopics.map(k => this.props.topics[this.props.topics.findIndex( j => j.uuid === k)].id)
        }
        return topicIds
    }
    
    componentDidMount(){
        this.props.getMyTopics(this.props.role);
        if(this.props.selectedTopics && this.props.selectedTopics.length){
            let t = this.getTopicIds();
            this.props.getTopicBlackList(t, this.props.role === 'ROLE_MARKER' ? true : false)
        }
    }

    componentDidUpdate(){
        if(this.props.selectedTopics && this.props.selectedTopics !== undefined){
            if(this.state.selectedTopics !== this.props.selectedTopics.join(',')){
                this.setState({
                    selectedTopics: this.props.selectedTopics.join(','),
                    topicBlackList: this.props.topicBlackList
                })
                this.props.setClearBlacklist();
                if(this.props.selectedTopics.length){
                    let t = this.getTopicIds();
                    this.props.getTopicBlackList(t, this.props.role === 'ROLE_MARKER' ? true : false)
                }
                    
            }
        }

    }

    getTopicName = (id, item) => {
        let k = this.props.topics ? this.props.topics.find((f,i)=>{return Number(f.id) === Number(id)}) : []
        return item ? k[item] : k
    }
    
    /*getTableHeader = (header) => {
        return header.map(k=> this.props.getValue(k))
    }*/

    getTableHeader = (header) => {
        let h = this.props.deviceType === 'mobile' ? header.map(k=> this.props.getValue(k)) : header.map(k=> this.props.getValue(k))
        return h
    }

    onTableItemsClick = (type, key, index) => {
        switch(type){
            case 'return':
                if(this.props.role === 'ROLE_MARKER')
                    this.props.removeFromBlackList(index, key);
                else
                    this.props.profileFromBlackList(index, key);
                setTimeout(() => {
                    let t = this.getTopicIds();
                    this.props.getTopicBlackList(t, this.props.role === 'ROLE_MARKER' ? true : false)
                }, 300) 
                
                break;
        }
    }

    setTableValues = (tableValues) => {

        return tableValues.map((k, i)=>{
                if(typeof(k[k.length-1]) !== "object"){
                    let id = k[1]
                    let topicId = k[2]
                    k[0] = i+1
                    k[2] = this.getTopicName(k[2], 'name')
                    if(this.props.deviceType === 'mobile'){
                        if(k[5] !== null){
                            k[3] = k[5]
                        }
                        else{
                            k[3] = <a href={k[4]} target="_blank">{k[3]}</a>
                        }
                    }
                    k[6] = this.props.getValue(k[6])
                    k.push(<ControlButtons keyId={id} callback={this.onTableItemsClick} items={["return"]}  index={topicId} />)
                }
            return k})

    }

    render() {
        
        return <BlackList 
                        data={this.props.topicBlackList.length && this.setTableValues(this.props.topicBlackList)} 
                        tableHeaderName={this.getTableHeader(this.props.tableHeader)} 
                        {...this.props}
                />
    }
}

export default BlackListController;